import React from "react";
import "./App.css";

export default function Footer() {
  return (
    <div className="Footer">
      <small>
        <a href={`https://github.com/pikolly/weather-react`}>
          Open source code
        </a>{" "}
        by Galit Atoll
      </small>
    </div>
  );
}
